import Exchanger from '../lib/exchange/exchanger-with-ping'
import Gateway from './gateway'
import MessageHandler from '../lib/exchange/message-handler'
import RequestTypes from '../lib/exchange-api/request-types'
import ErrorCodes from '../lib/exchange-api/error-codes'
import Config from '../lib/exchange-api/config'

import AuthRequestPass from './requests/auth-request-pass'
import AuthRequestToken from './requests/auth-request-token'
import AuthRefreshToken from './requests/auth-refresh-token'
import GetUiConfigRequest from './requests/get-ui-config-request'
import SetParamRequest from './requests/set-param-request'
import GetParamRequest from './requests/get-param-request'
import GetAllParamsRequest from './requests/get-all-params-request'
import GetAllUsersRequest from './requests/get-all-users-request'
import AddUserRequest from './requests/add-user-request'
import DeleteUserRequest from './requests/delete-user-request'
import GetNewSoftwareRequest from './requests/get-new-software-request'
import CmdUpdateSoftwareRequest from './requests/cmd-update-software'
import GetServerWorkStateRequest from './requests/get-server-work-state'
import CmdCheckNewSoftwareRequest from './requests/cmd-check-new-software'
import SendGetParamHistoryRequest from './requests/get-param-history-request'

import errorResponse from '../lib/exchange/error-response'

const errorResponses = {
    invalidMessageFormat: null,
    missingFieldReq: errorResponse.generate(ErrorCodes.MISSING_FIELD_REQ, null, 'Required field "req" not found.'),
    missingFieldReqId: errorResponse.generate(ErrorCodes.MISSING_FIELD_REQ_ID, null, 'Required field "req_id" not found.'),
    invalidFieldReqIdType: errorResponse.generate(ErrorCodes.INVALID_FIELD_TYPE, null, 'Field "req_id" must be integer.'),
    invalidReq: errorResponse.generate(ErrorCodes.INVALID_REQ, null, '')
}
var message_handler = new MessageHandler(errorResponses);
var exchanger = null

var isinitialized = false
var gateway = new Gateway(Config);

export default {
    initialize : async function(onOpen, onClose) {
        if(!isinitialized) {
            exchanger = new Exchanger(gateway, message_handler, null, onOpen, onClose);
            gateway.createConnection()
            isinitialized = true
        }
    },

    initRequests : function (updParam, updConfigVersion, updUpdateSoftwareFinish, updNewSoftware, updServerWorkState, updUpdateSoftwareProgress){
        message_handler.onRequest(RequestTypes.UPD_PARAM, updParam);
        message_handler.onRequest(RequestTypes.UPD_UI_CFG_VERSION, updConfigVersion);
        message_handler.onRequest(RequestTypes.UPD_UPDATE_SOFTWARE_FINISH, updUpdateSoftwareFinish);
        message_handler.onRequest(RequestTypes.UPD_NEW_SOFTWARE, updNewSoftware);
        message_handler.onRequest(RequestTypes.UPD_SERVER_WORK_STATE, updServerWorkState);
        message_handler.onRequest(RequestTypes.UPD_UPDATE_SOFTWARE_PROGRESS, updUpdateSoftwareProgress);
    },

    sendAuthParam : async function(login, pass_hash, auth_token, generate_auth_token){
        if (auth_token == null) return await exchanger.sendRequest(new AuthRequestPass(login, pass_hash, generate_auth_token))
        return await exchanger.sendRequest(new AuthRequestToken(login, auth_token, generate_auth_token))
    },

    sendRefreshToken : async function(){
        return await exchanger.sendRequest(new AuthRefreshToken())
    },
    
    sendGetUiConfig : async function(){
        return await exchanger.sendRequest(new GetUiConfigRequest())
    },
    
    sendGetParam : async function(param_id){
        return await exchanger.sendRequest(new GetParamRequest(param_id))
    },

    sendGetAllParams : async function(){
        return await exchanger.sendRequest(new GetAllParamsRequest())
    },

    sendSetParam : async function(param_id, param_value){
        return await exchanger.sendRequest(new SetParamRequest(param_id, param_value))
    },

    sendGetAllUsers : async function(){
        return await exchanger.sendRequest(new GetAllUsersRequest())
    },

    sendAddUser : async function(username, login, pass_hash){
        return await exchanger.sendRequest(new AddUserRequest(username, login, pass_hash))
    },

    sendDeleteUser : async function(login){
        return await exchanger.sendRequest(new DeleteUserRequest(login))
    },

    sendGetNewSoftware : async function(mode){
        return await exchanger.sendRequest(new GetNewSoftwareRequest(mode))
    },
    
    sendCmdUpdateSoftware : async function(mode){
        return await exchanger.sendRequest(new CmdUpdateSoftwareRequest(mode))
    },

    sendGetServerWorkState : async function(){
        return await exchanger.sendRequest(new GetServerWorkStateRequest())
    },

    sendCmdCheckNewSoftware : async function(){
        return await exchanger.sendRequest(new CmdCheckNewSoftwareRequest())
    },

    sendGetParamHistory : async function(param_id, duration){
        return await exchanger.sendRequest(new SendGetParamHistoryRequest(param_id, duration))
    }
}

